export const RESET_CAMERA = 'RESET_CAMERA';

export const resetCamera = () => dispatch => dispatch({ type: RESET_CAMERA });
